import { Base, ClaimLevel } from '@akiba/models_bimbo';
import { BehaviorSubject } from 'rxjs';


export class Claims extends Base {

    akiba: boolean;
    administrator: boolean;
    supervisor: boolean;
    employee: boolean;
    role: number;
    currentClaimLevel: ClaimLevel;
    maxClaimLevel: ClaimLevel;

    sideBarItems = new Array<any>();
    menuItems = new Array<any>();
    claimLevelChange: BehaviorSubject<number> = new BehaviorSubject<number>(0);
    environment: any;

    constructor(data: any | null = null) {

        super();
        this.akiba = false;
        this.administrator = false;
        this.supervisor = false;
        this.employee = false;
        this.role = 0;
        this.currentClaimLevel = ClaimLevel.notSet;

        this.load(data);

        if (this.employee) {
            this.currentClaimLevel = ClaimLevel.employee;
            this.maxClaimLevel = ClaimLevel.employee;
        }

        if (this.supervisor) {
            this.currentClaimLevel = ClaimLevel.supervisor;
            this.maxClaimLevel = ClaimLevel.supervisor;
        }

        if (this.administrator) {
            this.currentClaimLevel = ClaimLevel.administrator;
            this.maxClaimLevel = ClaimLevel.administrator;
        }

        if (this.akiba) {
            this.currentClaimLevel = ClaimLevel.akiba;
            this.maxClaimLevel = this.currentClaimLevel;
        }

    }

    async loadAccessForClaim(): Promise<boolean> {

        let mi: Array<any>;

        if (this.currentClaimLevel === 1) {
            this.sideBarItems = this.environment.sidebarRoutes.employee.tabs;
        }

        if (this.currentClaimLevel === 2) {
            this.sideBarItems = this.supervisor ? this.environment.sidebarRoutes.supervisor.tabs : [];
        }

        if (this.currentClaimLevel === 3) {
            this.sideBarItems = this.administrator ? this.environment.sidebarRoutes.administrator.tabs : [];
        }

        if (this.currentClaimLevel === 4) {
            this.sideBarItems = this.akiba ? this.environment.sidebarRoutes.akiba.tabs : [];
        }

        if (this.maxClaimLevel === 1) {
            mi = this.environment.sidebarRoutes.employee.menus;
        }

        if (this.maxClaimLevel === 2) {
            mi = this.supervisor ? this.environment.sidebarRoutes.supervisor.menus : [];
        }

        if (this.maxClaimLevel === 3) {
            mi = this.administrator ? this.environment.sidebarRoutes.administrator.menus : [];
        }

        if (this.maxClaimLevel === 4) {
            mi = this.akiba ? this.environment.sidebarRoutes.akiba.menus : [];
        }

        if (mi.length) {
            this.menuItems = mi;
            this.claimLevelChange.next(this.currentClaimLevel);
        } else {
            return false;
        }

        return true;

    }

    async matchPath(path: string): Promise<boolean> {

        let tempClaimLevel = 0;
        const found = this.menuItems.some(element => {
            const aPath: string = element.path;
            if (path.startsWith(aPath)) {
                tempClaimLevel = element.claimLevel;
                return true;
            }
        });

        if (found) {
            this.currentClaimLevel = tempClaimLevel;
        }

        return found;

    }

    hasValidClaim(): boolean {
        return this.currentClaimLevel !== ClaimLevel.notSet;
    }

    get currentClaim(): ClaimLevel {
        return this.currentClaimLevel;
    }

}
